/*
 * @Descripttion:
 * @Author: hejiajun
 * @Date: 2026-02-02 10:13:17
 * @LastEditors: hejiajun
 * @LastEditTime: 2026-03-14 00:00:00
 */

/**
 * 创建并追加一个 import map 脚本到文档头部
 * @param {string} name - 脚本类型，例如 'systemjs-importmap'
 * @param {Object} importmapConfig - import map 配置对象
 * @returns {HTMLScriptElement} 创建的脚本元素
 * @throws {TypeError} 如果 name 不是字符串或 importmapConfig 不是对象
 */
const createImportMapScript = (name, importmapConfig) => {
  // 参数验证
  if (typeof name !== "string" || !name.trim()) {
    throw new TypeError('Parameter "name" must be a non-empty string');
  }

  if (typeof importmapConfig !== "object" || importmapConfig === null) {
    throw new TypeError('Parameter "importmapConfig" must be a valid object');
  }

  try {
    const realScript = document.createElement("script");
    realScript.type = name;
    realScript.textContent = JSON.stringify(importmapConfig);
    document.head.appendChild(realScript);

    return realScript;
  } catch (error) {
    console.error("创建 import map 脚本时出错:", error);
    throw error;
  }
};

/**
 * 创建并插入一个 import map 脚本，在指定的参考元素之前
 * @param {string} name - 脚本类型，例如 'systemjs-importmap'
 * @param {Object} importmapConfig - import map 配置对象
 * @param {Element|string|null} [beforeRef=null] - 参考元素：可以是 DOM 元素、选择器字符串，或 null（默认追加到头部）
 * @returns {HTMLScriptElement} 创建的脚本元素
 * @throws {TypeError} 如果 name 不是字符串或 importmapConfig 不是对象
 */
const createImportMapScriptWithRef = (
  name,
  importmapConfig,
  beforeRef = null,
) => {
  // 参数验证
  if (typeof name !== "string" || !name.trim()) {
    throw new TypeError('Parameter "name" must be a non-empty string');
  }

  if (typeof importmapConfig !== "object" || importmapConfig === null) {
    throw new TypeError('Parameter "importmapConfig" must be a valid object');
  }

  try {
    const realScript = document.createElement("script");
    realScript.type = name;
    realScript.textContent = JSON.stringify(importmapConfig, null, 2); // 格式化便于调试

    let refElement = null;

    if (beforeRef instanceof Element) {
      // 如果传入的是 DOM 元素
      refElement = beforeRef;
    } else if (typeof beforeRef === "string") {
      // 如果传入的是选择器（如 '#my-script' 或 '[data-importmap-target]'）
      refElement = document.querySelector(beforeRef);

      if (!refElement) {
        console.warn(`参考元素未找到: ${beforeRef}`);
      }
    }
    // 如果 beforeRef 是 null 或未找到元素，则 fallback 到 append

    if (refElement && refElement.parentNode) {
      // 在 refElement 之前插入
      refElement.parentNode.insertBefore(realScript, refElement);
    } else {
      // 否则追加到 <head>
      document.head.appendChild(realScript);
    }

    return realScript; // 可选：返回元素以便后续操作
  } catch (error) {
    console.error("创建 import map 脚本时出错:", error);
    throw error;
  }
};

export { createImportMapScript, createImportMapScriptWithRef };
